module.exports = __webpack_public_path__ + "static/media/checkmark-blue.a76eacf6.svg";